/**
 * Collect the de-duplicated member id list for a new club chat.
 *
 * Extracted from CreateChatMatrix so the selection logic (interests +
 * hand-picked users + "everyone" + "include yourself") is unit-testable.
 */
export interface MemberSelection {
	usersByInterests?: { id: string }[];
	selectedUsers: { id: string }[];
	allClubUsers: { id: string }[];
	self?: { id: string } | null;
	includeAll: boolean;
	includeYourself: boolean;
}

export function collectMemberIds(selection: MemberSelection): string[] {
	const members: { id: string }[] = [
		...(selection.usersByInterests ?? []),
		...selection.selectedUsers,
	];
	if (selection.includeAll) {
		members.push(...selection.allClubUsers);
	}
	if (selection.includeYourself && selection.self) {
		members.push(selection.self);
	}
	return Array.from(new Set(members.map((user) => user.id)));
}
